import { DraftConfiguration } from '@/types';
import { trackStep } from '@/utils/adobeLaunch';
import { getViewId } from '@/model/printArea/getViewId';

export function trackAddToCart(
  productTypeId: string,
  appearanceId: string,
  configurations: DraftConfiguration[],
  selectedSizes: Record<string, number>,
  price: number,
  discount: number | undefined,
  currencyId: string,
  detail?: string
) {
  trackStep('addToCart', {
    products: Object.entries(selectedSizes).map(([sizeId, quantity]) => ({
      productTypeId,
      appearanceId,
      sizeId,
      price,
      quantity,
      configurations: configurations.map((configuration) => ({
        printAreaId: configuration.printArea.id,
        printTypeId: configuration.printType.id,
        type: configuration.type,
        viewId: getViewId(configuration.printArea),
      })),
    })),
    currencyId,
    volumeDiscount: discount,
    detail,
  });
}
